import { getLecturerParamList } from "@/api/lecturer";
import { resCategoryTree } from "@/api/rescategory";
import { getSysParamByTypes } from "@/api/sysParam";
import { getVideoListByName } from "@/api/videoSet";
import { Confirm } from "@/components/Confirm";
import FileHandler from "@/utils/file";
import { getItem } from "@/utils/storage.js";
import moment from "moment";

export default {
  data() {
    // 校验输入字数的最大长度
    var maxLength = (rule, value, callback, length) => {
      if (value.length > length) {
        callback(new Error(`最多输入${length}个字`));
      } else {
        callback();
      }
    };
    return {
      videoTagList: [],
      json: {},
      lect: "",
      videoSetData: [],
      videoCategoryData: [],
      videoTypeData: [],
      videoSourceData: [],
      lecturerData: [],
      publicData: [],
      videoForm: {
        videoLink: "",
        videos: [],
        videoLength: 0,
        videoSize: 0,
        isHot: 0,
        isRecommended: 0,
        onlineStatus: 0,
        qualityLevel: 0,
        videoAuditStatus: 0,
        videoAuditType: 0,
        videoSetId: "",
        // liveTime: "",
        liveDate: [],
        videoName: "",
        categoryId: "",
        videoSource: "",
        lecturerId: "",
        lecturerNa: "",
        expireTime: moment()
          .add(3, "year")
          .format("YYYY-MM-DD"),
        videoType: "",
        isRequired: "",
        coverUrl: "",
        isWeb: "",
        isApp: "",
        isApplet: "",
        isPc: "",
        covers: [],
        videoDesc: "",
        attachmentList: [],
        attachment: "",
        fileUrl: "",
        isSetCredit: 1,
        videoCredit: 0,
        playBaseNum: 0,
        likeBaseNum: 0,
        isDirectOnline: "",
        tagKeyList: []
      },
      rules: {
        videoLink: [
          {
            required: true,
            message: "请选择视频内容",
            trigger: "change"
          }
        ],
        videoName: [
          {
            required: true,
            message: "请输入视频名称",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              maxLength(rule, value, callback, 200);
            },
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请选择视频分类",
            trigger: ["change", "blur"]
          }
        ],
        attachmentList: [
          {
            required: true,
            message: "请上传审核意见",
            trigger: ["change", "blur"]
          }
        ],
        videoCredit: [
          {
            required: true,
            message: "请输入视频学分",
            trigger: ["change", "blur"]
          }
        ],
        playBaseNum: [
          {
            required: true,
            message: "请输入播放量基数",
            trigger: ["change", "blur"]
          }
        ],
        likeBaseNum: [
          {
            required: true,
            message: "请输入点赞基数",
            trigger: ["change", "blur"]
          }
        ],
        videoSource: [
          {
            required: true,
            message: "请选择视频来源",
            trigger: ["change", "blur"]
          }
        ],
        lecturerId: [
          {
            required: true,
            message: "请选择讲师",
            trigger: ["blur", "change"]
          }
        ],
        expireTime: [
          {
            required: true,
            message: "请选择有效期",
            trigger: ["blur", "change"]
          }
        ],
        videoType: [
          { required: true, message: "请选择视频类型", trigger: "change" }
        ],
        isRequired: [
          { required: true, message: "请选择是否必修", trigger: "change" }
        ],
        coverUrl: [
          {
            required: true,
            message: "请上传视频封面",
            trigger: "change"
          }
        ],
        videoDesc: [
          {
            validator: (rule, value, callback) => {
              maxLength(rule, value, callback, 2000);
            },
            trigger: "blur"
          }
        ],
        isSetCredit: [
          {
            required: true,
            message: "请选择学分配置",
            trigger: "change"
          }
        ],
        isDirectOnline: [
          {
            required: true,
            message: "请选择是否直接上线",
            trigger: "change"
          }
        ]
      },
      showProgress: false,
      progress: {
        videoProgress: 0
      },
      expireTimeOption: {
        disabledDate(date) {
          return (
            date.getTime() < new Date(moment().format("YYYY-MM:DD")).getTime()
          );
        }
      }
    };
  },
  created() {
    this.getSysParamByTypes(["RECOMMEND_TAG", "VIDEO_SOURCE", "VIDEO_TYPE", "IS_VALID"]);
    // 获取视频分类数据
    const params = {
      categoryType: 0,
      display: 1
    }
    resCategoryTree(params).then(res => {
      if (!res || res.code != 0) return;
      this.videoCategoryData = res.data;
    });
  },
  watch: {
    "videoForm.videos": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.videoLink = val[0].url;
          this.videoForm.videoSize = val[0].size;
        } else {
          this.videoForm.videoLink = "";
          this.videoForm.videoSize = 0;
        }
      }
    },
    "videoForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.coverUrl = val[0].url;
        } else {
          this.videoForm.coverUrl = "";
        }
      }
    }
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // 视频标签
        this.videoTagList = res.data["RECOMMEND_TAG"] || [];
        // 获取视频来源数据字典
        this.videoSourceData = res.data["VIDEO_SOURCE"] || [];
        // 获取视频类型数据字典
        this.videoTypeData = res.data["VIDEO_TYPE"] || [];
        if (this.videoTypeData.length > 0 && !this.edit) {
          // 设置默认选中
          this.videoForm.videoType = this.videoTypeData[0].paramKey;
        }
        // 获取通用数据字典数据
        this.publicData = res.data["IS_VALID"] || [];
        if (this.publicData.length > 0 && !this.edit) {
          // 设置默认选中
          this.videoForm.isRequired = this.publicData[0].paramKey;
          this.videoForm.isApp = this.publicData[1].paramKey;
          this.videoForm.isWeb = this.publicData[1].paramKey;
          this.videoForm.isApplet = this.publicData[1].paramKey;
          this.videoForm.isPc = this.publicData[1].paramKey;
          // this.videoForm.isSetCredit = this.publicData[1].paramKey;
          this.videoForm.isDirectOnline = this.publicData[0].paramKey;
        }
      });
    },
    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.$refs["videoForm"].resetFields();
        this.videoForm.videoType = this.videoTypeData[0].paramKey;
        this.videoForm.isRequired = this.publicData[0].paramKey;
        // this.videoForm.isSetCredit = this.publicData[1].paramKey;
        this.videoForm.isDirectOnline = this.publicData[0].paramKey;
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 提交清空数据
    clearHistoryData() {
      this.$refs["videoForm"].resetFields();
      this.videoForm.videos = [];
      this.videoForm.covers = [];
      this.videoForm.videoType = this.videoTypeData[0].paramKey;
      this.videoForm.isRequired = this.publicData[0].paramKey;
      this.videoForm.isDirectOnline = this.publicData[0].paramKey;
    },
    // 搜索视频集
    searchVideoSet(query) {
      getVideoListByName({ videoSetName: query }).then(res => {
        if (!res || res.code != 0) return;
        this.videoSetData = res.data;
      });
    },
    // 搜索讲师
    searchLecturer(query) {
      getLecturerParamList({ lecturerName: query }).then(res => {
        if (!res || res.code != 0) return;
        if (res.code == 0) {
          this.lecturerData = res.data.records;
        }
      });
    },
    // 学分配置改变
    creditChange(val) {
      if (val === "0") {
        this.videoForm.videoCredit = 0;
      } else {
        this.getVideoCredit(getItem('duration'))
      }
    },
    // 视频学分配置改变
    videoCreditChange(val) {
      this.videoForm.videoCredit = val;
    },
    // 观看次数配置改变
    playBaseNumChange(val) {
      this.videoForm.playBaseNum = val;
    },
    // 点赞基数改变
    likeBaseNumChange(val) {
      this.videoForm.likeBaseNum = val;
    },
    // 视频上传进度
    videoProgress(p) {
      this.showProgress = true;
      this.progress.videoProgress = p;
      if (p >= 100) {
        this.showProgress = false;
        this.progress.videoProgress = 0;
      }
    },
    // 上传封面
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const isImage = await FileHandler.isImage(file);
      if (!isImage) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning"
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`video/img`, file).then(res => {
        const { url } = res;
        this.videoForm.coverUrl = url;
      });
    },
    // 删除视频  时长重置为0
    deleteVideo() {
      this.videoForm.videos = [];
      this.videoForm.videoLength = 0;
    },
    // 删除封面
    deleteCover() {
      this.videoForm.covers = [];
    },
    videoDuration(t) {
      this.videoForm.videoLength = t;
    }
  }
};
